// Slice 40 — deterministic-tone initials avatar.

const TONES = [
  "#22d3ee",
  "#a78bfa",
  "#fbbf24",
  "#34d399",
  "#60a5fa",
  "#fb7185",
  "#f472b6",
  "#fb923c",
] as const;

export function HqAvatar({
  name = "?",
  size = 28,
  tone,
}: { name?: string; size?: number; tone?: string }) {
  const hash = [...name].reduce((a, c) => a + c.charCodeAt(0), 0);
  const bg = tone ?? TONES[hash % TONES.length];
  const initials =
    name
      .split(/\s+/)
      .filter(Boolean)
      .slice(0, 2)
      .map((p) => p[0] ?? "")
      .join("")
      .toUpperCase() || "?";
  return (
    <span
      style={{
        width: size,
        height: size,
        borderRadius: "var(--hq-radius-md)",
        display: "inline-grid",
        placeItems: "center",
        background: `${bg}1f`,
        color: bg,
        fontSize: Math.round(size * 0.36),
        fontWeight: 600,
        fontFamily: "var(--hq-font-sans)",
        border: `1px solid ${bg}33`,
        flexShrink: 0,
      }}
    >
      {initials}
    </span>
  );
}
